module.exports = __webpack_public_path__ + "img/sdm-logo-sml.4e7ed52c.png";